import { useGetList } from "ra-core";
import { Link } from "react-router";
import { subDays } from "date-fns";
import { AlertTriangle } from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";

import type { Subscription } from "../types";

// Sprint 9.2 — ChurnBanner : abonnements annulés sur les 30 derniers jours.
// Source : subscriptions.canceled_at IS NOT NULL AND canceled_at >= now() - 30d.

export const ChurnBanner = () => {
  const thirtyDaysAgo = subDays(new Date(), 30).toISOString();
  const { data } = useGetList<Subscription>("subscriptions", {
    pagination: { page: 1, perPage: 50 },
    sort: { field: "canceled_at", order: "DESC" },
    filter: {
      "canceled_at@gte": thirtyDaysAgo,
      "canceled_at@neq": null,
    },
  });

  const churned = data ?? [];
  if (churned.length === 0) return null;
  const first = churned[0];

  return (
    <Card className="border-fabrik-red/40">
      <CardContent className="py-3 md:py-3.5">
        <div className="flex items-start gap-2.5">
          <div className="size-7 rounded-md bg-fabrik-red-soft text-fabrik-red flex items-center justify-center shrink-0">
            <AlertTriangle className="size-3.5" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[13px] font-semibold text-foreground leading-tight">
              {churned.length} abonnement{churned.length > 1 ? "s" : ""} annulé
              {churned.length > 1 ? "s" : ""} (30 derniers jours)
            </p>
            <p className="text-[12px] text-fabrik-text-3 mt-0.5 truncate">
              {first.product_name ?? "Plan inconnu"}
              {first.company_id != null && (
                <>
                  {" · "}
                  <Link
                    to={`/companies/${first.company_id}/show`}
                    className="text-fabrik-red hover:underline"
                  >
                    voir entreprise
                  </Link>
                </>
              )}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
